import { Component, ViewEncapsulation, Input } from '@angular/core';

@Component({
  selector: 'tidy-bookable-legend',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './bookable-legend.component.html',
  styleUrls: ['./bookable-legend.component.scss'],
})
export class BookableLegendComponent {

  @Input() public labelOn: string = 'Bookable';
  @Input() public labelOff: string = 'Not Bookable';

}
